import { CHECKOUT_RELATEDITEMS_RECIVE } from '../../Rutab/RutabConstants';

const defaultState = {
    items: [],    
    errors: {},
};

export const checkoutRelatedItems = (state = defaultState, action) => {
    switch (action.type) {
        case CHECKOUT_RELATEDITEMS_RECIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
